import React from 'react';

const FOOTER = () => {
    return(
        <div className="footer">
            <div id="footer_text">
                <p>Inspired by Moneyman - A Senior Experience project.</p>
                <p>By Quang Nguyen. CSU San Marcos. Business Administration - MIS</p>
            </div>
        </div> 
    )
}

export default FOOTER;